module.exports = __webpack_public_path__ + "static/media/in.14a2c397.svg";